export const RefreshBroadcastChannelName = 'SINCERIUS_Refresh';
export const RefreshBroadcastMessage = 'SINCERIUS_Message';
